import * as type from '../types/aifkey';


let init = {
    saveForm: "",
    holderData: null,
    catType: null,
}

export default function aifDetails(state = init, action) {

    switch (action.type) {
        case type.SAVE_SUCCESS:
            return {
                ...state,
                saveForm: action.payload
            }
        case type.SAVE_HOLDER_DATA:
            return {
                ...state,
                holderData: action.payload
            }
        case type.CAT_TYPE:
            return {
                ...state,
                catType: action.payload
            }


        default:
            return state
    }
}